import React from 'react';
import { Award, Shield, Users, Target } from 'lucide-react';
import './WhyPartner.css';

const WhyPartner = ({ t, isVisible }) => {
  const reasons = [
    {
      icon: <Award size={40} />,
      title: t.whyPartner.reason1.title,
      description: t.whyPartner.reason1.description
    },
    {
      icon: <Shield size={40} />,
      title: t.whyPartner.reason2.title,
      description: t.whyPartner.reason2.description
    },
    {
      icon: <Users size={40} />,
      title: t.whyPartner.reason3.title,
      description: t.whyPartner.reason3.description
    },
    {
      icon: <Target size={40} />,
      title: t.whyPartner.reason4.title,
      description: t.whyPartner.reason4.description
    }
  ];

  return (
    <section id="why-partner" className={`why-partner ${isVisible ? 'visible' : ''}`}>
      <div className="why-partner-container">
        <div className="why-partner-content">
          <div className="why-partner-text">
            <h2 className="why-partner-title">{t.whyPartner.title}</h2>
            <p className="why-partner-subtitle">{t.whyPartner.subtitle}</p>
            
            <div className="reasons-grid">
              {reasons.map((reason, index) => (
                <div key={index} className="reason-item" style={{ animationDelay: `${index * 0.15}s` }}>
                  <div className="reason-icon">{reason.icon}</div>
                  <div className="reason-content">
                    <h3 className="reason-title">{reason.title}</h3>
                    <p className="reason-description">{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="compliance-scope-text">
              <p>{t.whyPartner.compliance}</p>
              <p>{t.whyPartner.scope}</p>
            </div>
          </div>

          <div className="why-partner-image">
            <img 
              src="https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg" 
              alt="Professional consulting environment"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyPartner;